import { render, staticRenderFns } from "./TCPlayer.vue?vue&type=template&id=59cc57e0&scoped=true&"
import script from "./TCPlayer.vue?vue&type=script&lang=js&"
export * from "./TCPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TCPlayer.vue?vue&type=style&index=0&id=59cc57e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc57e0",
  null
  
)

export default component.exports